import React from "react";
import { Shield, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { APP_NAME } from "@/constants/app";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl p-6 sm:p-10 shadow-sm border border-slate-200">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs font-semibold text-sif-primary hover:underline mb-6"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Funds
        </Link>

        <div className="flex items-center gap-3 mb-6 pb-4 border-b border-slate-200">
          <div className="w-10 h-10 rounded-xl bg-sif-primary flex items-center justify-center text-white">
            <Shield className="w-6 h-6" />
          </div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
              Privacy Policy
            </h1>
            <p className="text-xs text-slate-500 font-medium mt-1">
              Last updated: {new Date().toLocaleDateString("en-US", { month: 'long', year: 'numeric' })}
            </p>
          </div>
        </div>

        <div className="space-y-6 text-sm text-slate-700 leading-relaxed">
          <section className="space-y-2">
            <h2 className="text-lg font-bold text-slate-900">1. Information We Collect</h2>
            <p>
              When you use {APP_NAME}, we may collect personal information that you provide voluntarily, such as your email address, phone number, and preferences when subscribing to insights or contacting support.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-slate-900">2. How We Use Your Information</h2>
            <p>
              We use collected information to provide analytics, maintain platform functionality, send product updates, respond to inquiries, and ensure compliance with relevant financial and technical regulations.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-slate-900">3. Data Protection & Security</h2>
            <p>
              We employ strict technical and organizational security measures to protect your data against unauthorized access, loss, or alteration. We do not sell your personal data to third parties.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-slate-900">4. Regulatory & Legal Disclosures</h2>
            <p>
              Specialized Investment Funds (SIFs) operate under SEBI guidelines. Information disclosed on this platform adheres to standard compliance protocols.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-slate-900">5. Contact Us</h2>
            <p>
              If you have any questions regarding this Privacy Policy, please contact our support team at{" "}
              <a href="mailto:arbfinancial@gmail.com" className="text-sif-primary font-semibold hover:underline">
                arbfinancial@gmail.com
              </a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
